// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AttachButton_root__HctAb {
  padding-right: 10px;
  padding-left: 12px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: transparent;
  border: 0;
}
.AttachButton_menu__content__V9UQD {
  z-index: 99;
  background: white;
}

.AttachButton_fileIcon__nEhOE {
  width: 18px;
  transform: rotate(-45deg);
}`, "",{"version":3,"sources":["webpack://./src/components/chats/ui/ChatBottomPanels/NewMessagePanel/AttachButton/AttachButton.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EAEA,uBAAA;EACA,SAAA;AAAF;AAOA;EACE,WAAA;EACA,iBAAA;AALF;;AAQA;EACE,WAAA;EACA,yBAAA;AALF","sourcesContent":[".root {\n  padding-right: 10px;\n  padding-left: 12px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n  background: transparent;\n  border: 0;\n\n  &Active {\n\n  }\n}\n\n.menu__content {\n  z-index: 99;\n  background: white;\n}\n\n.fileIcon {\n  width: 18px;\n  transform: rotate(-45deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `AttachButton_root__HctAb`,
	"menu__content": `AttachButton_menu__content__V9UQD`,
	"fileIcon": `AttachButton_fileIcon__nEhOE`
};
export default ___CSS_LOADER_EXPORT___;
